import React from "react";
import heroImg from "@/app/blog/(posts)/solved/hero.png";
import type { ArticleMetadata } from "@/components/articles/ArticleMetadata.js";


export const blogSolved: ArticleMetadata = {
    id: "blogSolved",
    shortTitle: "Solving the Royal Game of Ur",
    fullTitle: "Solving the Royal Game of Ur",
    htmlTitle: (
        <>
            Solving the
            {" "}
            <br className="hidden md:block" />
            <span className="text-emphasis">
                Royal Game of Ur
            </span>
        </>
    ),
    description: "Here's our story of how we started trying to make bots that could compete with people, and ended up solving the Royal Game of Ur completely!",
    htmlDescription: <>
        Here&apos;s our story of how we started trying to make
        bots that could compete with people, and ended up
        solving the Royal Game of Ur completely!
    </>,
    path: "/blog/solved",
    date: "10th March, 2025",
    datetime: "20250310T090000Z",
    authors: [{
        name: "Padraig Lamont",
        url: "https://padraiglamont.com",
    }],
    image: {
        src: heroImg,
        alt: "Our new flawless Panda bot quietly considering a position.",
    },
    dir: [
        { label: "Home", href: "/" },
        { label: "Blog", href: "/blog" },
    ],
};
